<template>
  <div class="bq-product-zqzs">
    <SectionTitle :title="'产品简介'" noSpacing></SectionTitle>
    <p class="title-desc">
      就诊前采集用户病情信息，包括用户的基本信息、病情症状描述、既往病史等，生成电子病历给医生，提升医疗效率
    </p>
    <div class="zqzs-descs">
      <div class="descs-item" v-for="item in datalist.desc" :key="item.title">
        <h3>{{ item.title }}</h3>
        <span>{{ item.desc }}</span>
      </div>
    </div>
    <SectionTitle :title="'产品优势'" noSpacing></SectionTitle>
    <div class="zqzs-adv">
      <InfoBox
        :col="2"
        :itemObj="item"
        v-for="item in datalist.adv"
        :key="item.advTitles"
      ></InfoBox>
    </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/website_v3/SectionTitle';
import InfoBox from '@/components/website_v3/InfoBox';

export default {
  name: 'zqzs',
  data() {
    return {
      datalist: {
        desc: [
          {
            title: '帮助用户',
            desc:
              '帮助用户准确描述自身情况，引导式地采集患病信息，为接下来的医患沟通做好准备；',
          },
          {
            title: '帮助医生',
            desc:
              '帮助医生提前了解用户病情，医生问诊时只需要针对个别点补充询问即可；',
          },
          {
            title: '节省时间',
            desc:
              '节省病历书写时间，自动生成规范的病历，医生只需在基础上修改即可。',
          },
        ],
        adv: [
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB15yueF4D1gK0jSZFKXXcJrVXa-96-96.png',
            advTitles: '规范化',
            advDesc:
              '通过医院大量规范化的主诉，整理而得的规范化、有效模版问题；',
          },
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB15_CfF4D1gK0jSZFyXXciOVXa-96-96.png',
            advTitles: '结构化',
            advDesc: '结构化的问题模版，帮助患者准确描述主诉情况。',
          },
        ],
      },
    };
  },
  components: {
    SectionTitle,
    InfoBox,
  },
};
</script>
<style lang="less" scoped>
.bq-product-zqzs {
  .title-desc {
    color: #333;
    font-size: 18px;
  }

  .zqzs-descs {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 60px 0 90px;

    .descs-item {
      width: 290px !important;
      padding: 20px;
      color: #fff;
      background-color: #014dba;
      border-radius: 4px;

      h3 {
        font-size: 20px;
      }

      span {
        font-size: 18px;
        font-weight: 300;
      }

      &:first-child {
        background-color: #003a8c;
      }

      &:last-child {
        background-color: #045bd8;
      }
    }
  }

  .zqzs-adv {
    display: flex;
    justify-content: space-between;
    .bq-infobox {
      width: 400px !important;
    }
  }

  /deep/ .bq-infobox {
    p {
      font-size: 18px;
    }
  }

  /deep/ .header-title {
    margin-bottom: 60px;
    padding-bottom: 0;
  }
}
</style>
